"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_STORE_DISPLAYS_WITH_PLANOGRAMS = void 0;
var client_1 = require("@apollo/client");
var fragments_1 = require("../fragments");
exports.GET_STORE_DISPLAYS_WITH_PLANOGRAMS = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetDisplaysWithPlanograms($input: StoreDisplaysInput!) {\n    displaysWithPlanograms(input: $input) {\n      ...DisplayFragmentWithPlanogram\n    }\n  }\n  ", "\n"], ["\n  query GetDisplaysWithPlanograms($input: StoreDisplaysInput!) {\n    displaysWithPlanograms(input: $input) {\n      ...DisplayFragmentWithPlanogram\n    }\n  }\n  ", "\n"])), fragments_1.DISPLAY_FRAGMENT_WITH_PLANOGRAM);
var templateObject_1;
